import { Directive } from '@angular/core';
import {AbstractControl, FormGroup, NG_VALIDATORS, ValidationErrors, ValidatorFn} from "@angular/forms";

@Directive({
  selector: '[appMatchingUsernames]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MatchingUsernamesDirective, multi: true }]
})
export class MatchingUsernamesDirective {

  validate(control: AbstractControl): ValidationErrors {
    return matchingUsernamesValidator(control)
  }
}

export const matchingUsernamesValidator:ValidatorFn = (control:FormGroup):ValidationErrors | null => {

  const username = control.get('username');
  const usernameCheck = control.get('usernameCheck');

  return username && usernameCheck && username.value !== usernameCheck.value ? {'usernameNotMatching':true} : null;

}
